import React from 'react'
import { ReportElementProps } from './ReportElement'

const ReportElementOther: React.FC<ReportElementProps> = ({
  reportId,
  element,
  favorites = false,
}) => {
  console.log('could not find element type')
  return null
}

export default ReportElementOther
